import { InfoTableRows } from './infoTable';
import { processHistoricSensorRow, formatHistoricSensorRow } from './historicSensors';

export const InstallationInfoColumn = ({
  timestampData,
  selectedUnitItem,
  processedKpodData,
  formatDate
}) => {
  return (
    <div className="col-12 col-lg-4 pt-0 mb-3 mb-lg-0">
      {/* Installation and Unit Usage Info */}
      <table className="table main-background mb-0 table-responsive">
        <tbody>
          <tr className="text-start">
            <td><strong className="text-muted">Installation date</strong></td>
            <td className="text-end text-muted">
              {timestampData.installation !== '-' ? timestampData.installation.split(' ')[0] : '-'}
            </td>
          </tr>
          <InfoTableRows 
            statusInfo={selectedUnitItem}
            data={[
              { label: 'Daily unit use', key: 'daily_unit_use' },
              { label: 'Total sensor use', key: 'total_kpod_use' },
            ]}
          />
          <tr className="text-start">
            <td><strong className="text-muted">Last init</strong></td>
            <td className="text-end text-muted">{timestampData.lastInit}</td>
          </tr>
          <tr className="text-start">
            <td><strong className="text-muted">Last roster login</strong></td>
            <td className="text-end text-muted">{timestampData.lastLogin}</td>
          </tr>
          <tr className="text-start">
            <td><strong className="text-muted">Last usage</strong></td>
            <td className="text-end text-muted">{timestampData.lastUsage}</td>
          </tr>
          <tr className="text-start">
            <td><strong className="text-muted">Last water reference</strong></td>
            <td className="text-end text-muted">{timestampData.waterReference}</td>
          </tr>
        </tbody>
      </table>
      
      {/* Historic Sensors Table */}
      <table className="table main-background table-responsive">
        <tbody>
          <tr className="text-start">
            <td colSpan="4"><strong className="text-muted">Historic sensors</strong></td>
          </tr>
          {processedKpodData.length === 0 ? (
            <tr>
              <td colSpan="4" className="py-2 text-muted text-center">
                No historic data available
              </td>
            </tr>
          ) : (
            <>
              <tr>
                <td className="py-1 px-2 text-muted small"><strong>ID</strong></td>
                <td className="py-1 px-2 text-muted small"><strong>From</strong></td>
                <td className="py-1 px-2 text-muted small d-none d-sm-table-cell"><strong>To</strong></td>
                <td className="py-1 px-2 text-muted small text-end"><strong>Uses</strong></td>
              </tr>
              {processedKpodData.map((kpodData, index) => {
                const rowData = processHistoricSensorRow(kpodData, index, processedKpodData);
                const formatted = formatHistoricSensorRow(rowData, formatDate);

                return (
                  <tr key={formatted.kpodId}>
                    <td className="py-1 px-2 text-muted small text-truncate" style={{ maxWidth: '80px' }}>
                      {formatted.kpodId}
                    </td>
                    <td className="py-1 px-2 text-muted small">
                      {formatted.installationFormatted}
                    </td>
                    <td className="py-1 px-2 text-muted small d-none d-sm-table-cell">
                      {formatted.installationEndFormatted}
                    </td>
                    <td className="py-1 px-2 text-muted small text-end">
                      {formatted.totalUsagesFormatted}
                    </td>
                  </tr>
                );
              })}
            </>
          )}
        </tbody>
      </table>
    </div>
  );
};